export default class BaseFieldsDrawer {
    init({
        lightBoxEl = null,
        getElementByIdFunction = () => {},
        changeDetectedFunction = () => {},
        updateUICallback = () => {},
        validationDetectedCallback = () => {},
        handlerIfNoSuchUserAfterAjax = () => {},
    }) {
        this.lightBoxEl = lightBoxEl
        this.getElementByIdFunction = getElementByIdFunction
        this.changeDetectedFunction = changeDetectedFunction
        this.updateUICallback = updateUICallback
        this.validationDetectedCallback = validationDetectedCallback
        this.handlerIfNoSuchUserAfterAjax = handlerIfNoSuchUserAfterAjax
        this.errors = {}
        return this
    }

    setValue(field, value) {
        field.removeClass('placeholder') // IE8 doesn't switch placeholder class when field value is set
        field[0].value = value
        field[0].prevValue = field[0].value
    }

    setFieldDisabled(field, disabled) {
        field.prop('disabled', disabled)
    }

    initFields() {}

    getObjectValues() {}

    getErrors() {
        return this.errors
    }

    validateFields(oldErrors) {}
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/BaseFieldsDrawer.js